export const SERVICE_ACTION_TYPES = {
  GET_POSITIONS: 'service/getPositions',
  GET_MANAGERS_CITIES: 'service/getManagersCities',
  GET_MANAGERS: 'service/getManagers',
  GET_LINKS: 'service/getLinks',
  UPLOAD_PHOTO: 'service/uploadPhoto',
  SET_THEME_LOCAL: 'service/setThemeLocal',
};
